import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import Select from 'react-select';
import actions from '../../redux/actions';
import { getRoleIds } from '../../utils';
import AvatarUploader from '../AvatarUploader';

class EditMember extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatar: '',
      useCompanyName: false,
      companyName: '',
      userTitle: '',
      roleIds: [],
      roleOptions: [],
      defaultRoleOptions: [],
      ownershipTypes: [],
      canCreateOwnMember: false,
      memberName: '',
      memberEmail: '',
      memberOwnership: [],
    };
  }

  componentWillMount() {
    let { type, fields, roles, ownershipTypes, member } = this.props;

    if (type === 'create') {
      roles = R.filter(
        (role) => fields.type && fields.type === parseInt(role.work_type, 10),
        roles
      );
      ownershipTypes = R.filter(
        (o) =>
          !o.work_type ||
          (fields.type && fields.type === parseInt(o.work_type, 10)),
        ownershipTypes
      );
    }
    roles = R.uniqBy(R.prop('title'), R.sortBy(R.prop('title'), roles));

    let roleOptions = [];
    roles.forEach((role) => {
      roleOptions.push({ value: role.id, label: role.title });
    });

    this.getDefaultRoleOptions(roleOptions, member.role_ids);

    this.setState({ ownershipTypes, roleOptions, roleIds: member.role_ids });
  }

  getDefaultRoleOptions = (options, roelIds) => {
    let defaultRoleOptions = [];
    roelIds.map((roleId) =>
      defaultRoleOptions.push(
        _.find(options, (option) => parseInt(option.value, 10) === roleId)
      )
    );

    this.setState({ defaultRoleOptions });
  };

  opened() {
    if (this.props.member.ownership) {
      this.setState({
        memberOwnership: this.props.member.ownership.ownership_type,
      });
    } else if (this.props.member.ownership_type_id) {
      this.setState({ memberOwnership: this.props.member.ownership_type_id });
    }

    let canCreateOwnMember =
      this.props.member.user_info.email === this.props.profile.email;
    if (this.props.profile.subscription_plan === 'pro-annual') {
      canCreateOwnMember = false;
    }

    this.setState({
      memberName: this.props.member.user_info.name,
      memberEmail: this.props.member.user_info.email,
      avatar: this.props.member.user_info.avatar,
      useCompanyName: this.props.member.user_info.use_company_name,
      companyName: this.props.member.user_info.company_name,
      userTitle: this.props.member.user_info.user_title,
      canCreateOwnMember,
    });
  }

  close() {
    this.props.onClose();
  }

  save(e) {
    e.preventDefault();

    this.props.hideAlert();

    const ownership_type_id = this.state.memberOwnership;

    if (this.state.roleIds.length === 0) {
      this.props.alert('error', "Please select member's role.");
    } else if (!ownership_type_id) {
      this.props.alert('error', "Please select member's ownership type.");
    } else {
      this.getDefaultRoleOptions(this.state.roleOptions, this.state.roleIds);

      let data = {
        name: this.state.memberName,
        email: this.state.memberEmail,
        role_ids: this.state.roleIds,
        ownership_type_id: ownership_type_id,
        avatar: this.state.avatar,
        company_name: this.state.companyName,
        user_title: this.state.userTitle,
        use_company_name: this.state.useCompanyName,
      };

      this.props.onSave(data);
      this.close();
    }
  }

  delete() {
    if (confirm('Are you sure you want to delete this member?')) {
      this.props.onDelete();
      this.close();
    }
  }

  handleUpload(file) {
    if (file && file.url) {
      this.setState({ avatar: file.url });
    } else {
      this.setState({ avatar: '' });
    }
  }

  handleCheck = (e) => {
    this.setState({ useCompanyName: e.target.checked });
  };

  handleChange = (e) => {
    this.setState({ [e.target.getAttribute('id')]: e.target.value });
  };

  handleSelectChange = (options) => {
    this.setState({ roleIds: getRoleIds(options) });
  };

  render() {
    const { member, profile } = this.props;
    const {
      roleOptions,
      defaultRoleOptions,
      ownershipTypes,
      avatar,
      canCreateOwnMember,
      memberName,
      memberEmail,
      useCompanyName,
      companyName,
      userTitle,
      memberOwnership,
    } = this.state;

    return (
      <Modal
        className="create-member-modal"
        show={this.props.open}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Form onSubmit={(e) => this.save(e)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Collaborator</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="mb4">
              <Col md={3}>
                <div className="member-photo text-center upload-photo">
                  <AvatarUploader
                    size="100"
                    readOnly={canCreateOwnMember}
                    image={avatar}
                    onUpload={(file) => this.handleUpload(file)}
                  >
                    <span className="text-gray btn-upload-photo">
                      Add a picture
                    </span>
                  </AvatarUploader>
                </div>
              </Col>
              <Col md={9}>
                <div className="member-name">
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="tooltip-name">
                        Please provide this collaborator's full legal name.
                      </Tooltip>
                    }
                    placement="right"
                  >
                    <FormGroup>
                      <FormControl
                        type="text"
                        id="memberName"
                        placeholder="Collaborator's full legal name"
                        required
                        value={memberName}
                        onChange={this.handleChange}
                        disabled={canCreateOwnMember}
                      />
                    </FormGroup>
                  </OverlayTrigger>
                  <FormGroup>
                    <FormControl
                      type="email"
                      id="memberEmail"
                      placeholder="Collaborator's email address"
                      required
                      value={memberEmail}
                      onChange={this.handleChange}
                      disabled
                    />
                  </FormGroup>
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="tooltip-company-name">
                        To be able to sign your agreement on behalf of your
                        company, go to your profile settings and check the box
                        marked "I will sign on behalf of a company.
                      </Tooltip>
                    }
                  >
                    <FormGroup>
                      <Checkbox
                        onChange={this.handleCheck}
                        checked={useCompanyName}
                        disabled={canCreateOwnMember}
                      >
                        This collaborator will sign on behalf of a company.
                      </Checkbox>
                    </FormGroup>
                  </OverlayTrigger>
                  {useCompanyName && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-company-name">
                          If this collaborator already has a Cosynd account,
                          they will need to fill in their company name, title,
                          and check the box marked “I will sign on behalf of a
                          company” in their profile before you create this team.
                        </Tooltip>
                      }
                    >
                      <FormGroup>
                        <FormControl
                          type="text"
                          id="companyName"
                          placeholder="Company name"
                          value={companyName}
                          onChange={this.handleChange}
                          disabled={canCreateOwnMember}
                        />
                      </FormGroup>
                    </OverlayTrigger>
                  )}
                  {useCompanyName && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-user-title">
                          If this collaborator already has a Cosynd account,
                          they will need to fill in their company name, title,
                          and check the box marked “I will sign on behalf of a
                          company” in their profile before you create this team.
                        </Tooltip>
                      }
                    >
                      <FormGroup>
                        <FormControl
                          type="text"
                          id="userTitle"
                          placeholder="Collaborator's title"
                          value={userTitle}
                          onChange={this.handleChange}
                          disabled={canCreateOwnMember}
                        />
                      </FormGroup>
                    </OverlayTrigger>
                  )}
                </div>
              </Col>
            </Row>
            <FormGroup controlId="member-role">
              <ControlLabel>What is this collaborator's role?</ControlLabel>
              <Select
                isMulti
                defaultValue={defaultRoleOptions}
                options={roleOptions}
                placeholder="Select role(s)"
                onChange={this.handleSelectChange}
              />
            </FormGroup>
            {/* <FormGroup>
              <Checkbox ref="defaultRole">
                Make this the default role for this collaborator
              </Checkbox>
            </FormGroup> */}
            <FormGroup>
              <ControlLabel>What does this collaborator own?</ControlLabel>
              <FormControl
                componentClass="select"
                id="memberOwnership"
                size="3"
                value={memberOwnership.toString()}
                onChange={this.handleChange}
              >
                {ownershipTypes &&
                  ownershipTypes.map((ownershipType, i) => (
                    <option key={i} value={ownershipType.id}>
                      {ownershipType.name}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>
            {/* <FormGroup>
              <Checkbox ref="defaultOwnership">
                Make this the default ownership type for this collaborator
              </Checkbox>
            </FormGroup> */}
          </Modal.Body>

          <Modal.Footer>
            <div className="actions">
              <Button bsStyle="link" onClick={() => this.close()}>
                cancel
              </Button>
              <div>
                {member &&
                  profile &&
                  member.user_info.email.toLowerCase() !==
                    profile.email.toLowerCase() && (
                    <Button
                      bsStyle="link"
                      className="btn-delete"
                      onClick={() => this.delete()}
                    >
                      delete
                    </Button>
                  )}
                <button type="submit">Save</button>
              </div>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  roles: state.global.roles,
  ownershipTypes: state.global.ownershipTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMember);



// WEBPACK FOOTER //
// src/components/Members/EditMember.jsx